'use strict';

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    ajax = require('../ajax'),
    cartStoreInventory = require('../storeinventory/cart'),
    dialog = require('../dialog'),
    dialogTooltip = require('../dialog-tooltip'),
    util = require('../util'),
    productTile = require('../product-tile'),
    validator = require('../validator'),
    internationalshipping = require('../internationalshipping'),
    tealium = require('../../../../int_tealium/cartridge/js/tealium/tealium');


function madeOfferAjax() {
    var url = Urls.madeOffer;
    $.getJSON(url, function (data) {
        var fail = false;
    });
}
/**
 * @description Last Visited slider events.
 */


function lastVisitedCart() {

    var $lastVisitedSearchResultItems = $(".last-visited .search-result-items"),
        ItemData = { 
            desktop: { slides: 3 ,scroll:1}, 
            tablet: { break: 1350, slides: 3 ,scroll:1},  
            Phablet: { break: 1024, slides: 3 ,scroll:1},
            mobile: { break: 767, slides: 3 ,scroll:1} ,
            sMobile: { break: 640, slides: 1.4 ,scroll:1}
        },
        totalItems = $lastVisitedSearchResultItems.children().length;
        ItemData.desktop.slides > totalItems ? ItemData.desktop.slides = totalItems :null;
        ItemData.tablet.slides > totalItems ? ItemData.tablet.slides = totalItems :null;
        ItemData.Phablet.slides > totalItems ? ItemData.Phablet.slides = totalItems :null;
        ItemData.mobile.slides > totalItems ? ItemData.mobile.slides = totalItems :null;
        
        
    var lastVisitedSlickConfig = {
        slidesToShow: ItemData.desktop.slides,
        slidesToScroll: ItemData.desktop.slides > totalItems ? ItemData.desktop.scroll :ItemData.desktop.slides,
        dots: false,
        infinite: false,
        arrows: true,
        responsive: [
            {
                breakpoint: ItemData.tablet.break,
                settings: {
                    slidesToShow: ItemData.tablet.slides,
                    slidesToScroll: ItemData.tablet.slides > totalItems ? ItemData.tablet.scroll :ItemData.tablet.slides,
                    arrows: true
                }
            },
            {
                breakpoint: ItemData.Phablet.break,
                settings: {
                    slidesToShow: ItemData.Phablet.slides,
                    slidesToScroll: ItemData.Phablet.slides > totalItems ? ItemData.Phablet.scroll :ItemData.Phablet.slides,
                    arrows: true
                }
            },
            {
                breakpoint: ItemData.mobile.break,
                settings: {
                    slidesToShow:  ItemData.mobile.slides,
                    slidesToScroll:  ItemData.mobile.scroll,
                    arrows: false
                }
            },{
                breakpoint: ItemData.sMobile.break,
                settings: {
                    slidesToShow:  ItemData.sMobile.slides,
                    slidesToScroll: ItemData.sMobile.scroll,
                    arrows: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    }

    // wraps slick arrows with <li> tags after slick initialization. SC-7702
    $lastVisitedSearchResultItems.on('init breakpoint', function(){
        if($lastVisitedSearchResultItems.prop('nodeName') == 'UL')
        $($lastVisitedSearchResultItems.children("button.slick-prev, button.slick-next")).wrap("<li></li>");
    });

    $lastVisitedSearchResultItems.slick(lastVisitedSlickConfig);

}


/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {

    var name = $(".offer-content").data("name");
    var creditLimit = $(".offer-content").data("creditlimit");
    $(".plcc-pre-approved-name").text(name);
    $(".plcc-pre-approved-creditlimit").text(creditLimit);


    lastVisitedCart();

    $('#cart-table').on('click', '.item-edit-details a:not(.select-bonus, .edit-sps)', function (e) {
    	if( $(window).width() > 1023 ) {
    		e.preventDefault();
    		var url = $(this).attr("href");
	        quickview.show({
	            url: url,
	            source: 'cart',
	            callback: function () {
                	validator.init();
	                //closes QV modal on overlay click
	                $('.ui-widget-overlay').bind('click', function () {
	                    $('#QuickViewDialog').dialog('close');
	                });
	            }
	        });
    	}
      
    })
        .on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
            e.preventDefault();
            bonusProductsView.show(this.href);
        });

    // To restrict the space value in promo input field.
    $('form input[name$="_couponCode"]').on('keypress', function (event) {        
        var k = event ? event.which : window.event.keyCode;
        if (k == 32) return false; 
    });

    // Convert final input value in uppercase with no space for case sensitive.
    $('body').on('blur', "form input[name$='_couponCode']", function (event) {
        var inputValChange = $(this).val().toUpperCase().replace(/ +?/g, '');
        $(this).val(inputValChange);
    });

    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        $(this).closest('.cart-coupon-code').find('.promo-error-exist').hide();
        var rewardCertificate = $(this).val().substring(0, 2);
        var validCoupon = new RegExp('\^[A-Za-z0-9-]+$'); 

        if (!validCoupon.test($(this).val()) && $(this).val() != '') {
            $(this).closest('.cart-coupon-code').find('.invalid-error').show();
        } else {
        	$(this).closest('.cart-coupon-code').find('.invalid-error').hide();
        }
        if (rewardCertificate == 'rw') {
            $(this).closest('.cart-coupon-code').find('.rw-error').show();
        } else {
            $(this).closest('.cart-coupon-code').find('.rw-error').hide();
        }
        if(String(e.key) == 'Enter' || Number(e.keyCode) == 13 ){
            e.preventDefault();
            $('#add-coupon').click();
        }
    });

    if ($('.error-coupon-invalid, .promo-error-exist').is(':visible')) {
        $('.coupon-code').focus();
    }

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });

    // Moved to global, Add toggle functionality for Promo Code in Cart
    //click on promo code + icon or 'enter promo code' text
    $('.promo-code-anchor').on('click',function(){
    	$('.pt_cart_template_b .cart-message').hide();
        $('.pt_cart_template_b .input-fields').show();
        if(window.lastClickOrKey === 'key'){
            $('.pt_cart_template_b .input-fields input.coupon-code').focus().addClass('focus-outline');
        }
    });
    
    //click on apply button for promo code
    $('.pt_cart_template_b button#add-coupon').on('submit',function(){        
    	$('.pt_cart_template_b .cart-message').hide();
    	$('.pt_cart_template_b .input-fields').show();
    });    
    
    // cart quantity update
    $('.custom-cart-update').on('click', '.qty-arrows', function (e) {
        e.preventDefault();
        var qtyBox = $(this).closest('.custom-cart-update').find('input');
        var curValue = qtyBox.val();

        if ($('.qty-arrows').hasClass('disabled')) {
            $('.qty-arrows').removeClass('disabled');
        }

        if ($(this).hasClass('qty-increase')) {

            if (curValue == 40) {
                $(this).addClass('disabled');
                return false;
            }
            curValue++;
            qtyBox.val(curValue);
        } else {
            if (curValue == 1) {
                $(this).addClass('disabled');
                return false;
            }
            curValue--;
            qtyBox.val(curValue);
        }
        $(this).closest("form").find('.pdt-Qty').val(curValue);
        $(this).closest(".cart-columns").find("button[value='Update']").trigger('click');
    });

    // WCAG enter event captured for Quantity Up and down 
    $('body').on('keypress','.qty-increase, .qty-decrease, .shippingoverlay-link', function(e) {
        if(e.which == '13'){
            e.preventDefault();
            $(this).trigger("click");  
        }
    });

    if ($('#wrapper').hasClass('pt_cart') || $('#wrapper').hasClass('pt_cart_template_b')) {
        $('.shippingoverlay-link').on('click', function (e) {
            e.preventDefault();
            var shippingoverlay = $('#shipping-overlay').html();
            dialog.open({
                html: shippingoverlay,
                options: {
                    width: 365,
                    dialogClass: 'shipping-overlay',
                    title: Resources.SHIPPING_OVERLAY_TITLE
                }
            });
        });
    }
    $('.cart-show-basket-id').on('click', function (e) {
        e.preventDefault();
        var options = {
            url: Urls.persisBasketCS,
            type: 'GET'
        };

        $.ajax(options).done(function (data) {

            if (typeof (data) !== 'string') {
                $('.cart-show-basket-id').html('<span aria-label="ID '+data.basketID.toString().split("").join(" ")+'">ID ' + data.basketID + '</span>');
                $('.cart-show-basket-id').toggleClass('cart-show-basket-id');
            }

        });
    });

    // WCAG focus after ajax load
    $('body').on('keyup', '.cart-show-basket-id', function (e) {        
        if(e.keyCode == 13){
            setTimeout(function(){
                $(this).closest('.shopping-bag-id').addClass('focus-outline').focus();
            }, 500);            
        }
    });

    $('.quick-order-badge-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(this).attr('href'),
            options: {
                dialogClass: 'quick-order-badge-link tooltip-dialog',
                width: 400
            }
        });
    });
    dialogTooltip.events();

    if ($(window).width() > 1024) {
        $('.cart-plcc-section').find('button').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.cart-plcc-section').toggleClass('active');
        });
    }
    
    productTile.init();


    $('body').off('click', '.intl-shipping-btn').on('click', '.intl-shipping-btn', function () {       
                
        if(SitePreferences.GLOBALE_ENABLED && !SitePreferences.GLOBALE_IS_PHASE2 ){            
            internationalshipping.getCountrySelectionModal(true); 
        }
        
        var eventData = {
            "event_name": "international_shipping", 
            "location": "cart"
        };
        tealium.triggerEvent(eventData);
    }).show();

    $('body').off('click', '#international-modal-submit').on('click', '#international-modal-submit', function (e) {
        internationalshipping.formSubmit(e);   
    });

}

/**
* @private
* @function
* @description Initialize additional functionality related with PayPal integration 
*/
function initPaypalFunctionality() {
    var dialog = require('../dialog');
    var util = require('../util');
    var $expressButton = $('.js_paypal_start_ba_checkout');

    $expressButton.on('click', function () {

        if ($expressButton.data('is-address-exist') === true) {
            return true;
        }

        dialog.open({
            url: $expressButton.data('edit-address-url'),
            options: {
                title: $expressButton.data('edit-address-title'),
                open: initEditDefaultShippingAddressForm
            }
        });

        return false;
    });

    function initEditDefaultShippingAddressForm() {
        /* PXSFCC-4495_WCAG_Modal_focus_management */
        $(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter", function () {
            $(this).focus();
        });
        $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
        var $form = $('#paypalEditDefaultShippingAddress');

        $form.on('click', '.apply-button', function () {

            if (!$form.valid()) {
                return false;
            }

            var applyName = $form.find('.apply-button').attr('name');

            var options = {
                url: $form.attr('action'),
                data: $form.serialize() + '&' + applyName + '=x',
                type: 'POST'
            };

            $.ajax(options).done(function (data) {

                if (typeof (data) !== 'string') {

                    if (data.success) {
                        dialog.close();
                        window.location = $expressButton.attr('href');
                    } else {
                        window.alert(data.message);
                        return false;
                    }

                } else {
                    $('#dialog-container').html(data);
                    initEditDefaultShippingAddressForm();
                }

            });

            return false;
        });

        $form.on('click', '.cancel-button, .close-button', function () {
            dialog.close();
            return false;
        });

        $('#paypalSelectSavedAddress').change(function () {
            var data = $(this).val();

            try {
                data = JSON.parse(data);

                for (name in data) {
                    var val = data[name];

                    if (typeof val === 'string') {
                        val = val.replace(/\^/g, "'");
                    }

                    $('#dwfrm_profile_address_' + name).val(val);
                }
            } catch (e) {
                $form.find('input:text').val('');
                $form.find('select').val('');
            }
        });
    }
}

function initInternationalFunctionality(){
    $(window).on('load',function(){
        if(localStorage.getItem('hasInvalidIntlItems')){
            internationalshipping.getCountrySelectionModal(true);
            localStorage.removeItem('hasInvalidIntlItems');
        }
    });
    $('body').on('submit','.cart-action-checkout',function(e){
        var globaleCookie = util.getCookie('GlobalE_Data').length ? JSON.parse(decodeURIComponent(util.getCookie('GlobalE_Data'))) : '';
        var globaleCookieCountry = globaleCookie && globaleCookie.countryISO;
        if(globaleCookieCountry && globaleCookieCountry != "US"){
            e.preventDefault();
            internationalshipping.getCountrySelectionModal(true); 
        }        
    });
}

function updateUtagDataInCart(){
    if(window.utag_data.user_country_ge != "US"){
        /** update the utag_data in USD for foreign currency**/
        var cartUSDUtagURL=Urls.globalECartUSDUtagData;
        $.ajax({ 
            url: cartUSDUtagURL,
            method: 'GET',
            success: function(data) {
                if(data.utagDL !== ''){
                    utag_data=data.utagDL;
                } 
            }
        });
    }
}
exports.init = function () {
    initializeEvents();
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    account.initCartLogin();
    initPaypalFunctionality();
    util.questionAndAnwserEvent();
    util.plccCartBannerAccordianEvent();
    initInternationalFunctionality();
    updateUtagDataInCart();
};
